import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private sharedSource = new Subject<void>();
  currentMessage = this.sharedSource.asObservable();

  sendMessage() {
    this.sharedSource.next();
  }
}
